import {
    get_mia_azienda,
    update_mia_azienda,
    upload_logo_azienda,
    elimina_logo_azienda,
    get_logo_azienda_blob,
} from "@/api/api.miaAzienda.js";

const miaAzienda = {
    namespaced: true,

    state: {
        dati: null,
        logoUrl: null, // object URL locale creato dal blob scaricato, vedi caricaLogo
    },

    mutations: {
        SET_DATI: (state, dati) => {
            state.dati = dati;
        },
        SET_LOGO_URL: (state, url) => {
            // Rilascia il precedente object URL prima di sostituirlo, altrimenti
            // resta agganciato in memoria finché la pagina non viene ricaricata.
            if (state.logoUrl) URL.revokeObjectURL(state.logoUrl);
            state.logoUrl = url;
        },
    },

    actions: {
        carica({ commit }) {
            return new Promise((resolve, reject) => {
                get_mia_azienda().then(resp => {
                    commit("SET_DATI", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, dati) {
            return new Promise((resolve, reject) => {
                update_mia_azienda(dati).then(resp => {
                    dispatch("carica").then(() => resolve(resp)).catch(() => resolve(resp));
                }).catch(err => reject(err));
            });
        },

        uploadLogo({ dispatch }, file) {
            return new Promise((resolve, reject) => {
                upload_logo_azienda(file).then(resp => {
                    Promise.all([dispatch("carica"), dispatch("caricaLogo")])
                        .then(() => resolve(resp)).catch(() => resolve(resp));
                }).catch(err => reject(err));
            });
        },

        eliminaLogo({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                elimina_logo_azienda().then(resp => {
                    commit("SET_LOGO_URL", null);
                    dispatch("carica").then(() => resolve(resp)).catch(() => resolve(resp));
                }).catch(err => reject(err));
            });
        },

        // Scarica il logo come blob e ne ricava un object URL da passare a <v-img>:
        // l'endpoint richiede autenticazione (header Authorization), quindi non può
        // essere referenziato direttamente come URL statico in un tag <img>.
        caricaLogo({ commit }) {
            return new Promise((resolve) => {
                get_logo_azienda_blob().then(resp => {
                    const url = URL.createObjectURL(resp.data);
                    commit("SET_LOGO_URL", url);
                    resolve(url);
                }).catch(() => {
                    // Nessun logo caricato per questo tenant (404) o utente senza
                    // azienda (SuperAdmin): nessun errore da mostrare, semplicemente
                    // niente logo nella sidebar.
                    commit("SET_LOGO_URL", null);
                    resolve(null);
                });
            });
        },
    },

    getters: {
        dati: state => state.dati,
        logoUrl: state => state.logoUrl,
    },
};

export default miaAzienda;
